import {Fragment} from 'react'
import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import Dealer from '../assets/industry_dealer_network.png'
import QSR from '../assets/industry_qsr.png'
import Retail from '../assets/industry_retail.png'
import Wellness from '../assets/industry_wellness.png'
import Landing from '../assets/landing.jpg'

export default function BecomeAMerchant() {
  return (
    <Fragment>
      <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
        <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
          <div className='flex-column-fluid'>
            <div id='' className=''>
              <div className='card'>
                <div
                  className='container-fluid d-flex align-items-stretch justify-content-between pt-8'
                  id='kt_app_header_container'
                >
                  <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                    <div
                      className='btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px ms-n2 me-2 d-flex d-lg-none'
                      id='kt_app_sidebar_mobile_toggle'
                    >
                      <i className='ki-outline ki-abstract-14 fs-1'></i>
                    </div>

                    <a href='sign-in'>
                      <img alt='Logo' src={Logo} className='h-30px' />
                    </a>
                  </div>

                  <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                    <div
                      className='d-flex align-items-stretch'
                      id='kt_app_header_menu_wrapper'
                    ></div>
                  </div>
                </div>

                <div className='card-body p-4 pt-7'>
                  <div className='d-flex flex-column flex-xl-row'>
                    <div className='flex-lg-row-fluid me-xl-15'>
                      <div className='mb-17'>
                        <div className='mb-8'>
                          <div className='overlay'>
                            <div
                              className='bgi-no-repeat bgi-position-center bgi-size-cover min-h-600px'
                              style={{
                                backgroundImage: `url(${Landing})`,
                                borderRadius: '0.42rem',
                              }}
                            ></div>

                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25 align-items-start justify-content-end p-15'>
                              <div className='d-flex flex-stack'>
                                <a
                                  className='p-2 px-4 rounded w-100 text-light pulse pulse-dark d-flex flex-column flex-start bg-primary'
                                  href='become-a-merchant/pricing'
                                >
                                  <div className='d-flex flex-row align-items-center gap-2'>
                                    <div className='d-flex align-items-center'>
                                      <i className='bi bi-arrow-right-circle me-3 fs-3 text-light'></i>
                                    </div>
                                    <div className='d-flex flex-column'>
                                      <span className='fs-5 fw-bold'>Become a Merchant</span>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='fs-5 fw-semibold text-gray-600'>
                          <h2 className='text-dark mb-7'>Merchant Mastery: Loyalty Elevated!</h2>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Our Merchant Portal empowers merchants to create loyal customers who
                            keep coming back. Start your journey with us and turn your shoppers into
                            lifelong fans.
                          </p>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Transform shopping into a rewarding experience for your customers with
                            The Extra Platform
                          </p>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Unlocking the potential of joining our Merchant Platform with limitless
                            revenue generation opportunities can be a game-changer for Small and
                            Medium-sized Enterprises (SMEs).
                          </p>

                          <p className='text-gray-600 fs-3 mb-5'>
                            By becoming a merchant, SMEs can supercharge their sales, nurture
                            unwavering customer loyalty, gain invaluable customer insights, slash
                            marketing expenses, elevate their brand recognition, tap into
                            cost-effective cross-promotion ventures, fine-tune rewards to suit their
                            unique business model, outshine competitors in their niche, cultivate
                            enduring customer relationships, and diversify revenue streams. It's the
                            ultimate growth catalyst that SMEs simply can't afford to miss.
                          </p>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Step into our merchant portal, your exclusive gateway to success,
                            spanning Retail, QSR, wellness, and dealership sectors.
                          </p>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Here, you'll unlock the full potential of a personalized loyalty program
                            to harmonize perfectly with your unique business strategy, ensuring you
                            reap maximum benefits and soaring profits.
                          </p>
                          <p className='text-gray-600 fs-3 mb-5'>
                            Select promotion structures, set them up effortlessly, initiate
                            engagement, and automate the process without the need for IT skills.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='flex-column flex-lg-row-auto w-100 w-xl-300px mb-10'>
                      <div className='m-0'>
                        <h4 className='text-dark mb-7'>By Industries</h4>

                        <div className='d-flex mb-7 align-items-center'>
                          <a
                            href='/become-a-merchant/retail'
                            className='fw-semibold d-block pt-1 fs-3'
                          >
                            <div className='symbol symbol-100px symbol-2by3 me-4'>
                              <div
                                className='symbol-label'
                                style={{
                                  backgroundImage: `url(${Retail})`,
                                }}
                              ></div>
                            </div>
                          </a>

                          <div className='m-0'>
                            <a
                              href='/become-a-merchant/retail'
                              className='fw-semibold d-block pt-1 fs-3'
                            >
                              Retail
                            </a>
                          </div>
                        </div>

                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${Wellness})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>Wellness</span>
                          </div>
                        </div>
                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${Dealer})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>Dealer Network</span>
                          </div>
                        </div>
                        <div className='d-flex mb-7 align-items-center'>
                          <div className='symbol symbol-100px symbol-2by3 me-4'>
                            <div
                              className='symbol-label'
                              style={{
                                backgroundImage: `url(${QSR})`,
                              }}
                            ></div>
                          </div>

                          <div className='m-0'>
                            <span className='fw-semibold d-block pt-1 fs-3'>QSR</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='kt_app_footer' className='app-footer sticky-bottom'>
        <div className='app-container container-fluid d-flex flex-column flex-md-row flex-center justify-content-start flex-md-stack py-3 bg-primary'>
          <div className='text-white fs-3 px-3'>Amplify Your Sales Today and Every Day!</div>

          <div className='d-flex flex-stack'>
            <a
              className='p-2 px-4 rounded ms-5 w-100 text-primary pulse pulse-dark d-flex flex-column flex-start'
              href='become-a-merchant/pricing'
              style={{
                backgroundColor: '#fff',
              }}
            >
              <div className='d-flex flex-row align-items-center gap-2'>
                <div className='d-flex align-items-center'>
                  <i className='bi bi-arrow-right-circle me-3 fs-3 text-primary'></i>
                </div>
                <div className='d-flex flex-column'>
                  <span className='fs-5 fw-bold'>Become a Merchant</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
